import api from '@/api/axios';
import {
  StateType,
  TextsetData,
  TextsetEditData,
} from '@/contexts/TextSetContext/types';

type TextSearchPayload = Omit<StateType, 'textLength'>;

export const getTexts = async (
  payload: TextSearchPayload,
): Promise<{ isError: false; data: TextsetData }> => {
  try {
    const { data } = await api.post(`/api/texts/search`, payload);
    return {
      isError: false,
      data,
    };
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getSelectedTexts = async (
  set: string | undefined,
  patientID: string | undefined,
  setId: string | undefined,
): Promise<{ isError: false; data: TextsetEditData }> => {
  try {
    const { data } = await api.get(
      `/api/patients/${patientID}/${set}/${setId}`,
    );
    return {
      isError: false,
      data,
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
